<template>
  <div class="table">
    <div class="container">
      <div>
        <p class="icon-jujue closeBtn" @click="routerBack"></p>
      </div>
      <div class="handle-box">
        <el-row type="flex" align="middle">
          <el-button v-acl="RMC_PROD_MEDUSAGE_SAVE" v-if="statusView=='S'" size="mini" type="primary" @click="saveData('detailInfo')">保存</el-button>
          <el-button v-acl="RMC_PROD_MEDUSAGE_SUBMIT" v-if="statusView=='S'" size="mini" type="primary" @click="submitData('detailInfo')">提交</el-button>
          <!-- <el-button size="mini"  type="primary">批准</el-button>
            <el-button size="mini"  type="primary">退回</el-button> -->
        </el-row>
      </div>

      <el-form :model="detailInfo" ref="detailInfo" :rules="rules" :label-position="labelPosition" label-width="120px" class="searchForm">
        <div class="handle-box">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">基本信息</p>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="报告期限" prop="reportDate">
                <el-select v-model="detailInfo.reportDate" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in allDate" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Farm" prop="rmcProduceFarmId">
                <el-select v-model="detailInfo.rmcProduceFarmId" :disabled="statusView=='S'?false:true" @change="getFarmGroupId" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in farmList" :label="item.farmName" :value="item.rmcProduceFarmId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商">
                <el-input disabled v-model="detailInfo.sponsorName" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Category3">
                <el-select v-model="detailInfo.category3Code" @change="getCategory3Name" :disabled="category3List.length>1&&statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="作物" prop="cultiVarName">
                <el-select v-model="detailInfo.cultiVarName" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in cropList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="种植亩数" prop="plantUnit">
                <el-input v-model="detailInfo.plantUnit" @blur="setDosage" maxlength="10" :disabled="statusView=='S'?false:true" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="亩产量(kg)" prop="yield">
                <el-input v-model="detailInfo.yield" @blur="setDosage" maxlength="10" :disabled="statusView=='S'?false:true" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="实际使用量(kg)" prop="realUse">
                <el-input v-model="detailInfo.realUse" maxlength="10" disabled oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="农药原粉量总量(g)/种植亩数(亩)" prop="pesticideUnit">
                <el-input v-model="detailInfo.pesticideUnit" maxlength="10" disabled oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="农药原粉量总量(g)/(亩产量*种植亩数)(ton)" prop="pesticideUnitTotal">
                <el-input v-model="detailInfo.pesticideUnitTotal" maxlength="10" disabled oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="状态">
                <ic-select table="TT_RMC_PRODUCE_MEDICINE_USAGE" disabled filterable field="STATUS" clearable v-model="detailInfo.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>

        </div>

        <div class="handle-box" style="margin-top:20px;">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">药品用量明细</p>
          </div>
          <el-row type="flex" style="margin-top:10px;" align="middle">
            <el-button v-acl="RMC_PROD_MEDUSAGE_ITEM_UPDATE" class="btn" type="primary" @click="addInventory">新增</el-button>
            <el-button v-acl="RMC_PROD_MEDUSAGE_ITEM_UPDATE" :disabled="multipleSelection.length>0?false:true" class="btn" type="danger" @click="delRow">删除</el-button>
          </el-row>
          <el-table ref="plxTable" :data="detailInfo.amountList" style="margin-top:10px;" max-height="500" @selection-change="selectionChange" show-overflow="ellipsis" highlight-current-row>
            <el-table-column sortable type="selection" width="55" align="center" fixed="left"></el-table-column>
            <el-table-column align="center" label="商品名" width="120" prop="productName">
              <template slot-scope="scope">
                <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.productName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="用途分类" align="center" width="120" prop="useClass"></el-table-column>
            <el-table-column label="生产厂家" align="center" width="130" prop="producer"></el-table-column>
            <el-table-column label="有效成分" align="center" show-overflow-tooltip prop="effectiveComponents"></el-table-column>
            <el-table-column label="净含量(%)(有效成分含量)" align="center" width="140" prop="netRate">
              <template slot="header">
                <span style="color:red;">*</span>
                <span>净含量(%)(有效成分含量)</span>
              </template>
              <template slot-scope="scope">
                <el-form-item label="" :prop="'amountList.' + scope.$index + '.netRate'" :rules="rules.netRate">
                  <!-- 只可以输入正数和小数 -->
                  <!-- oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"  -->
                  <el-input v-model="scope.row.netRate" @blur="setNetUsage(scope.row)" :disabled="statusView=='S'?false:true" placeholder="请输入内容"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="使用量(kg)" align="center" width="130" prop="usage">
              <template slot="header">
                <span style="color:red;">*</span>
                <span>使用量(kg)</span>
              </template>
              <template slot-scope="scope">
                <el-form-item label="" :prop="'amountList.' + scope.$index + '.usage'" :rules="rules.usage">
                  <el-input v-model="scope.row.usage" @blur="setNetUsage(scope.row)" :disabled="statusView=='S'?false:true" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="使用次数" align="center" width="130" prop="usageNumber">
              <template slot="header">
                <span style="color:red;">*</span>
                <span>使用次数</span>
              </template>
              <template slot-scope="scope">
                <el-form-item label="" :prop="'amountList.' + scope.$index + '.usageNumber'" width="130" :rules="rules.usageNumber">
                  <el-input v-model="scope.row.usageNumber" @blur="setNetUsage(scope.row)" :disabled="statusView=='S'?false:true" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="换算原粉量(kg)(使用量*净含量%)" width="180" align="center">
              <template slot-scope="scope">
                <el-form-item label="">
                  <el-input v-model="scope.row.netUsage" disabled placeholder="请输入内容"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
        <div slot="title" class="header-title">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">药品清单</p>
          </div>
        </div>
        <inventoryList v-if="dialogVisible" @close="handleClose"></inventoryList>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
// import detailDialog from './MaintainceFacility.vue'
import ratingTask from "@/api/AAA/ratingTask.js";
import QBRApi from "@/api/QBR/index";
import apiService from "@/api/AAA/index.js";
import commonFunction from "@/utils/dataTableUtils";
import inventoryList from '@/components/page/RMC/Produce/rmcProDrugDosage/inventoryList'
import proMedicineDosage from '@/api/rmcProduce/proMedicineDosage'
import proteinDrug from "@/api/rmcProtein/drug";
import prodMedicine from "@/api/rmcProduce/prodMedicine";
import rules from './rules'
import { json } from "body-parser";



export default {
  name: '',
  components: {
    inventoryList,
    IcSelect,
    // detailDialog
  },
  data() {
    return {
      farmList: [],
      detailInfo: {
        amountList: [],
        status: "DRAFT"
      },
      dialogVisible: false,
      identity: localStorage.getItem('ms_emplFlag'),
      allDate: [],
      multipleSelection: [],
      category3List: [],
      statusList: [],
      fileTable: [],
      isShow: false,
      showDetailDialog: false,
      tableData: [],
      formData: null,
      totalCount: "",
      statusView: "",
      rules: rules,
      cropList: [],

    }
  },
  created() {
    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
    } else {
      if (ms_roles.indexOf("QSPI_RMC_PRODUCE_CQS") != -1) {
        this.statusView = 'C'
      }
    }
    if (!this.$route.query.id) {
      this.getSponsorByUser()
    }
    this.getFarmList()
    this.getdCategory3()
    this.getSelector()
    if (this.$route.query.id) {
      this.getDetail()
    }
  },
  methods: {

    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'produce'
        })
        if (this.category3List.length == 1) {
          this.detailInfo.category3Code = this.category3List[0].key
          this.detailInfo.category3Name = this.category3List[0].object
          this.$refs['detailInfo'].clearValidate(['category3Code']);
        }
      })
    },
    getSelector() {
      proMedicineDosage.getSelector().then((res) => {
        res.data.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.allDate.push(obj)
        })
      })
    },
    getDetail() {
      proMedicineDosage.medicineUsageDetail(this.$route.query.id).then((res) => {
        if (res.code == 200) {
          this.getFarmGroupId(res.data.rmcProduceFarmId)
          this.detailInfo = res.data
        }
      })
    },
    getFarmList() {
      prodMedicine.getSelectorForFram().then((res) => {
        this.farmList = res.data
      })
    },
    getSponsorByUser() {
      proteinDrug.getSponsorByUser().then((res) => {
        this.$set(this.detailInfo, "sponsorCode", res.data.supplierCode)
        this.$set(this.detailInfo, "sponsorName", res.data.supplierName)
      })
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    //根据选中Category2查询Category3
    changeCategory2() {
      this.categoryList3 = []
      QBRApi.getCategoryLists({ categoryLevel: 3, category2Codes: this.detailInfo.category2CodesList }).then((res) => {
        this.categoryList3 = res.data;
      });
    },
    getFarmGroupId(val) {
      if (val) {
        this.$set(this.detailInfo, 'cultiVarName', '')
        this.cropList = []
        proMedicineDosage.getFarmName(val).then((res) => {
          res.data.forEach((v) => {
            let obj = {}
            obj.name = v
            obj.code = v
            this.cropList.push(obj)
          })
        })
      }
    },
    addInventory() {
      if (!this.detailInfo.cultiVarName) {
        this.$message.error('请先选择作物')
      } else {
        let params = JSON.parse(JSON.stringify(this.detailInfo))
        let data = this.farmList.filter((v) => {
          return v.rmcProduceFarmId == this.detailInfo.rmcProduceFarmId
        })
        params.farmName = data[0].farmName
        sessionStorage.setItem("rmcProDrugDosageInfo", JSON.stringify(params))
        this.dialogVisible = true
      }
    },
    setNetUsage(row) {
      console.log("🚀 ~ file: detail.vue:319 ~ setNetUsage ~ row", row)
      let num = 0
      if (row.netRate && row.usage) {
        // netRate:净含量(%)(有效成分含量)
        // usage:使用量(kg)
        // usageNumber:使用次数
        // netUsage:换算原粉量(kg)(使用量*净含量%)
        num = Number(row.netRate / 100) * Number(row.usage) * Number(row.usageNumber)
        console.log("🚀 ~ file: detail.vue:327 ~ setNetUsage ~ num", num)
        this.$set(row, 'netUsage', num.toFixed(8))
      }
      this.setDosage()
    },
    delRow() {
      if (this.multipleSelection.length > 0) {
        let params = {
          amountIds: []
        }
        this.multipleSelection.forEach((v) => {
          params.amountIds.push(v.ttRmcProduceMedicineUsageAmountId)
        })
        proMedicineDosage.deleteAmount(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.detailInfo.amountList = this.detailInfo.amountList.filter((v) => {
              return params.amountIds.indexOf(v.ttRmcProduceMedicineUsageAmountId) == -1
            })
            this.setDosage()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请至少选择一条数据')
      }

    },
    onDownload(val) {

    },
    handleClose(val) {
      if (val && val.length > 0) {
        let params = {
          produceMedicineList: val
        }
        proMedicineDosage.saveAmount(params).then((res) => {
          console.log("🚀 ~ file: detail.vue:365 ~ proMedicineDosage.saveAmount ~ res", res)
          res.data.forEach((v) => {
            v.netRate = v.contents
          })
          if (res.code == 200) {
            if (this.detailInfo.amountList && this.detailInfo.amountList.length > 0) {
              this.detailInfo.amountList = this.detailInfo.amountList.concat(res.data)
            } else {
              this.detailInfo.amountList = res.data
            }
          }
          console.log("点击选择后过来的数据===", res)
        })
      }
      this.dialogVisible = false
    },
    saveData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setDosage()
          if (this.detailInfo.amountList.length > 0) {
            proMedicineDosage.saveMedicineUsage(this.detailInfo).then((res) => {
              if (res.code == 200) {
                this.$message.success('保存成功')
                this.routerBack()
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error("请添加药品用量明细")
          }

        } else {

          return false;
        }
      });
    },
    setDosage() {
      let num = 0
      // netUsage:换算原粉量(kg)(使用量*净含量%)
      console.log('this.detailInfo.amountList', this.detailInfo.amountList);
      this.detailInfo.amountList.forEach((v) => {
        num += Number(v.netUsage)
      })
      console.log("实际使用量", num)
      this.$set(this.detailInfo, 'realUse', num.toFixed(4))   //实际使用量
      // plantUnit:种植亩数  yield:亩产量
      if (this.detailInfo.plantUnit) {
        //农药原粉总量(g)/种植亩数(亩)=实际使用量(kg)*1000/种植亩数
        var num1 = num * 1000 / this.detailInfo.plantUnit
        this.$set(this.detailInfo, 'pesticideUnit', num1.toFixed(4))
      }
      if (this.detailInfo.plantUnit && this.detailInfo.yield) {
        //农药原粉总量(g)/(亩产量*种植亩数)(ton)=实际使用量(kg)*1000/(亩产量*种植亩数)*0.001
        var num2 = num * 1000 / ((this.detailInfo.plantUnit * this.detailInfo.yield) * 0.001)
        this.$set(this.detailInfo, 'pesticideUnitTotal', num2.toFixed(4))
      }
    },
    getCategory3Name(val) {
      let getName = this.category3List.filter((v) => {
        return v.key == val
      })
      this.detailInfo.category3Name = getName[0].object
    },
    submitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setDosage()
          if (this.detailInfo.amountList.length > 0) {
            proMedicineDosage.submitMedicineUsage(this.detailInfo).then((res) => {
              if (res.code == 200) {
                this.$message.success('提交成功')
                this.routerBack()
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error("请添加药品用量明细")
          }
        } else {
          return false;
        }
      });
    },
    routerBack() {
      this.$router.back();
    }

  },
  extends: commonFunction
}
</script>
<style scoped >
/deep/ .el-table__body-wrapper .el-form-item__content {
  margin-left: 0px !important;
}
/deep/ .el-table__body-wrapper .searchForm .el-form-item--mini.el-form-item,
.searchForm .el-form-item--small.el-form-item {
  margin: 15px 0px !important;
}
.searchForm .el-col {
  margin-top: 10px;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
